import { AxiosPromise } from 'axios' // eslint-disable-line no-unused-vars
import getBasePath from '@util/path'
import { RuleV2, RuleV2Api, RuleV2Mutation } from '@clients/myTrips' // eslint-disable-line no-unused-vars
import appendCredentials from '@util/appendCredentials'

let basePath = getBasePath() + '/my-trips'

export default class ExtendedRuleV2Api extends RuleV2Api {
  getRulesV2 (options?: any): AxiosPromise<Array<RuleV2>> {
    const optionsParam = appendCredentials(options)
    optionsParam.basePath = basePath
    return super.getRulesV2(undefined, optionsParam)
  }

  getRuleV2 (id: string, options?: any): AxiosPromise<RuleV2> {
    const optionsParam = appendCredentials(options)
    optionsParam.basePath = basePath
    return super.getRuleV2(id, undefined, optionsParam)
  }

  createRuleV2 (ruleRequestBody: RuleV2Mutation, options?: any): AxiosPromise<RuleV2> {
    const optionsParam = appendCredentials(options)
    optionsParam.basePath = basePath
    return super.createRuleV2(ruleRequestBody, undefined, optionsParam)
  }

  updateRuleV2 (id: string, ruleRequestBody: RuleV2Mutation, options?: any): AxiosPromise<RuleV2> {
    const optionsParam = appendCredentials(options)
    optionsParam.basePath = basePath
    return super.updateRuleV2(id, ruleRequestBody, undefined, optionsParam)
  }
}
